import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=39b990ee&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"
import style0 from "./Auth.vue?vue&type=style&index=0&id=39b990ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b990ee",
  null
  
)

export default component.exports